import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LoginApi } from "../Services/authService";
import { LOGIN } from "../../api/constApi";

export const logInAdmin = createAsyncThunk(LOGIN, async (payload) => {
    const response = await LoginApi(payload);
    return response.data;
  });
  
export const authSlice = createSlice({  
    name: "auth",
    initialState: {
        user: null,
        token: null,
        error: null,
    },
    reducers: {
        logOutUser(state) {
            localStorage.clear();
            state.user = null;
          },
    },
    extraReducers: (builder) => {
        builder.addCase(logInAdmin.fulfilled, (state, action) => {
            localStorage.setItem("accessToken", action?.payload?.Data?.accessToken);
            state.user = action?.payload?.Data;
        });
    }
});

export default authSlice.reducer;

export const { logOutUser } = authSlice.actions;

